export const getEventStatusEnum = (state) => state.eventStatusEnum
export const getEventStatus = (state) => state.eventStatus
export const getEventTypes = (state) => state.eventTypes
export const getCurrentEvent = (state) => state.currentEvent
export const getEventPermissions = (state) => state.eventPermissions
export const getInscriptionStatusEnum = (state) => state.inscriptionStatusEnum
export const getEventParticipators = (state) => state.participators
export const getVariables = (state) => state.variables
export const getInvitationStatus = (state) => state.invitationStatus
export const getTemplateKey = (state) => state.templateKey
export const getCurrentInvitation = (state) => state.currentInvitation
export const getEventValidatedParticipators = (state) => state.validatedParticipators
